import { supabase } from '@/lib/supabaseClient';
import type { Collection, UpcomingCollection } from '@/types/collection';

export interface CollectionsCatalog {
  collections: Collection[];
  /** Анонсы «Скоро» — только для витрины. */
  upcoming: UpcomingCollection[];
  /**
   * Открыто ли создание портретов (app_config.generation_open). Старый
   * сервер поля не присылает — тогда открыто: решение всё равно за сервером.
   */
  generationOpen: boolean;
}

interface CollectionsResponse {
  collections: Collection[];
  upcoming?: UpcomingCollection[];
  generationOpen?: boolean;
}

/** Публичный каталог коллекций — без авторизации, кэш 5 минут на сервере. */
export async function fetchCatalog(): Promise<CollectionsCatalog> {
  if (!supabase) {
    return { collections: [], upcoming: [], generationOpen: true };
  }

  const { data, error } = await supabase.functions.invoke<CollectionsResponse>('collections');

  if (error || !data) {
    throw new Error('Не удалось загрузить список коллекций.');
  }

  return {
    collections: data.collections,
    upcoming: data.upcoming ?? [],
    generationOpen: data.generationOpen !== false,
  };
}
